import { AxiosInstance } from "axios"

export interface ApiKey {
  id: number
  name: string
  created_at: string
  expires_at: string | null
  last_used_at: string | null
  is_active: boolean
}

export interface CreatedApiKey {
  id: number
  /** Plaintext token — shown exactly once at creation, never retrievable again */
  token: string
  name: string
  created_at: string
  expires_at: string | null
  scopes: string
}

export interface CreateApiKeyPayload {
  name: string
  /** Omitted → default 1 year; explicit null → never expires */
  expires_at?: string | null
}

export interface IApiKeysApi {
  list: () => Promise<ApiKey[]>
  create: (payload: CreateApiKeyPayload) => Promise<CreatedApiKey>
  revoke: (id: number) => Promise<void>
}

const apiKeysApi = (axiosClient: AxiosInstance): IApiKeysApi => ({
  list: async () => {
    const { data } = await axiosClient.get<ApiKey[]>("/auth/api-keys/")
    return data
  },
  create: async payload => {
    const { data } = await axiosClient.post<CreatedApiKey>("/auth/api-keys/", payload)
    return data
  },
  revoke: async id => {
    await axiosClient.delete(`/auth/api-keys/${id}/`)
  },
})

export default apiKeysApi
